import React from "react";
import { bool } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** List with outer border */
  bordered: bool,
  /** List without any borders(on <ul/> and <li/> elements) */
  clean: bool,
  /** List with smaller spacing between items */
  condensed: bool,
};

const CLASS_ROOT = "list";

const List = ({
  className,
  bordered,
  clean,
  condensed,
  children,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--bordered`]: bordered,
      [`${CLASS_ROOT}--clean`]: clean,
      [`${CLASS_ROOT}--condensed`]: condensed,
    },
    className
  );

  return (
    <ul className={classes} {...other}>
      {children}
    </ul>
  );
};

List.displayName = "List";
List.propTypes = propTypes;

export default List;
